class ESMFormulaCompiler {
    variables;
    dados;

    constructor(dados) {
        this.dados = dados;
    }

    COUNT = (codigo, etapa_pergunta_codigo) => {
        return this.dados.filter(item => etapa_pergunta_codigo ? item['Etapa_Pergunta_codigo'] === etapa_pergunta_codigo : item['Pergunta_codigo'] === codigo).length;
    }

    VALUE = (codigo, etapa_pergunta_codigo) => {
        return this.dados.find(item => etapa_pergunta_codigo ? item['Etapa_Pergunta_codigo'] === etapa_pergunta_codigo : item['Pergunta_codigo'] === codigo)?.Resposta;
    }

    COLETA = (codigo, etapa_pergunta_codigo) => {
        return this.dados.find(item => etapa_pergunta_codigo ? item['Etapa_Pergunta_codigo'] === etapa_pergunta_codigo : item['Pergunta_codigo'] === codigo)?.Escala || 0;
    }

    BASE = (startEscala, endEscala, start, end, indice) => {
        const diffEscala = endEscala - startEscala;
        const diffValor = end - start;
        const startValor = indice - start;
        const progress = startValor / diffValor;
        return startEscala + (diffEscala * (progress))
    }

    getValue = (criterio) => {
        try {
            const func = new Function(
                criterio
                    .replace(/(COLETA|VALUE|COUNT)\(#([\w]+)\)/g, '$1("$2")')
                    .replace(/(COLETA|VALUE|COUNT|BASE)\(/g, "this.$1(")
            ).call(this);
            return func;
        } catch (e) {
            console.log({ e })
            return 0
        }
    }
}

export default ESMFormulaCompiler;